import ChatFileRow from './ChatFileRow.component';

export default ChatFileRow;
